<template>
  <nav class="navbar">
    <div class="navbar-brand">
      <router-link :to="{ name: 'home' }" class="navbar-item">
        <img
          v-if="$parent.theme == 'default'"
          src="../assets/images/ueg_logo.svg"
          class="logotype"
        />
        <img
          v-if="$parent.theme == 'ford'"
          src="../assets/images/ford/ford.svg"
          class="logotype"
        />
      </router-link>

      <!-- <a
        role="button"
        class="navbar-burger burger"
        aria-label="menu"
        aria-expanded="false"
        data-target="navbarBasicExample"
      >
        <span aria-hidden="true"></span>
        <span aria-hidden="true"></span>
        <span aria-hidden="true"></span>
      </a> -->
    </div>

    <div class="navbar-menu">
      <!--div class="navbar-start">
          <router-link to="/projects" class="navbar-item is-tab">
            Dashboard
          </router-link>
          <router-link to="/settings" class="navbar-item is-tab">
            Settings
          </router-link>
          <router-link
            :to="{ name: 'projectRequests' }"
            class="navbar-item is-tab"
          >
            Project Request Form
          </router-link>
        </div-->

      <div class="navbar-start">
        <router-link
          v-for="r in navbar"
          :to="r.route"
          class="navbar-item is-tab"
          active-class="is-active"
        >
          {{ r.text }}
        </router-link>
      </div>

      <div class="navbar-end">
        <div class="navbar-item">
          <button
            class="button is-bug-report is-outlined is-small"
            @click="reportBugDialog = true"
          >
            <span class="icon icon-bug"></span>
            <span>
              Report a bug
            </span>
          </button>
        </div>
        <div class="navbar-item">
          <div class="has-text-right role-container">
            <div class="user-role-header">
              {{ $store.getters.userFullnameAbrev }}
            </div>
            <!--div class="organization">{{ $store.getters.userRole }}</div-->
          </div>
        </div>
        <div class="navbar-item buttons has-addons">
          <button
            class="button is-secondary is-outlined button-logout is-small"
            @click="logout"
          >
            <span class="icon-logout"></span>
          </button>
        </div>
      </div>
    </div>

    <app-modal v-model="reportBugDialog" title="Report a bug">
      <ValidationObserver v-slot="{ handleSubmit }" slim>
        <form @submit.prevent="handleSubmit(submitBug)">
          <div class="columns is-multiline">
            <div class="column is-6">
              <ValidationProvider
                v-slot="{ errors, failed }"
                rules="email"
                class="field"
                tag="div"
              >
                <label class="label">Your Email (optional)</label>
                <div class="control">
                  <input
                    v-model="bugReport.UserEmail"
                    class="input"
                    type="email"
                    :class="{ 'is-danger': failed }"
                  />
                </div>
                <span class="help is-danger">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
            <div class="column is-3">
              <ValidationProvider
                v-slot="{ errors, failed }"
                rules="required"
                class="field"
                tag="div"
              >
                <label class="label">Priority</label>
                <div class="control">
                  <div class="select" :class="{ 'is-danger': failed }">
                    <select v-model="bugReport.Priority">
                      <option>1 - Low</option>
                      <option>2 - Medium</option>
                      <option>3 - High</option>
                    </select>
                  </div>
                </div>
                <span class="help is-danger">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
            <div class="column is-12">
              <ValidationProvider
                v-slot="{ errors, failed }"
                rules="required"
                class="field"
                tag="div"
              >
                <label class="label">Describe the issue</label>
                <div class="control">
                  <textarea
                    v-model="bugReport.ProblemDescription"
                    class="textarea"
                    :class="{ 'is-danger': failed }"
                    rows="3"
                  ></textarea>
                </div>
                <span class="help is-danger">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
            <div class="column is-12">
              <ValidationProvider
                v-slot="{ errors, failed }"
                rules="required"
                class="field"
                tag="div"
              >
                <label class="label">Where did you find the issue?</label>
                <div class="control">
                  <textarea
                    v-model="bugReport.ProblemLocation"
                    class="textarea"
                    :class="{ 'is-danger': failed }"
                    rows="3"
                  ></textarea>
                </div>
                <span class="help is-danger">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
            <div class="column is-12">
              <ValidationProvider
                v-slot="{ errors, failed }"
                rules="required"
                class="field"
                tag="div"
              >
                <label class="label">
                  What did you expect to see or happen?
                </label>
                <div class="control">
                  <textarea
                    v-model="bugReport.AdditionalDetails"
                    class="textarea"
                    rows="3"
                    :class="{ 'is-danger': failed }"
                  ></textarea>
                </div>
                <span class="help is-danger">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
            <div class="column is-6">
              <div class="field">
                <label class="label">
                  Attach a screenshot
                </label>
                <div class="control">
                  <div class="file has-name is-fullwidth is-right">
                    <label class="file-label">
                      <input
                        ref="fileToUpload"
                        class="file-input"
                        type="file"
                        @change="
                          $set(bugReport, 'FileContent', $event.target.files[0])
                        "
                      />
                      <span class="file-cta">
                        <span class="file-icon">
                          <i class="icon icon-upload"></i>
                        </span>
                        <span class="file-label">
                          Upload
                        </span>
                      </span>
                      <span class="file-name">
                        {{
                          (bugReport.FileContent &&
                            bugReport.FileContent.name) ||
                            'No file selected'
                        }}
                      </span>
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="has-text-centered">
            <button type="submit" class="button is-primary">Report</button>
          </div>
        </form>
      </ValidationObserver>
    </app-modal>
  </nav>
</template>

<script>
import AppModal from '@/components/AppModal.vue';
// import { ValidationProvider, ValidationObserver } from 'vee-validate';

export default {
  name: 'AppHeader',
  components: { AppModal },
  data() {
    return {
      reportBugDialog: false,
      bugReport: {}
    };
  },
  computed: {
    navbar() {
      /*const routes = [
        {
          route: { name: 'team' },
          text: 'Team'
        },
        {
          route: { name: 'projectRequests' },
          text: 'Forms'
        },
        {
          route: { name: 'settings' },
          text: 'Settings'
        }
      ];
      if (this.hasRole('ueg')) {
        routes.unshift({
          route: { name: 'organizations' },
          text: 'Organizations'
        });
      } else {
        routes.unshift({
          route: { name: 'projects.list' },
          text: 'Projects'
        });
      }*/
      let routes = [];
      if (this.hasRole('ueg')) {
        routes = [
          {
            route: { name: 'organizations' },
            text: 'Organizations'
          },
          {
            route: { name: 'team' },
            text: 'Team'
          },
          {
            route: { name: 'projectRequests' },
            text: 'Forms'
          },
          {
            route: { name: 'settings' },
            text: 'Settings'
          }
        ];
      } else {
        routes = [
          {
            route: { name: 'projects.list' },
            text: 'Projects'
          },
          {
            route: { name: 'team' },
            text: 'Team'
          },
          {
            route: { name: 'settings' },
            text: 'Settings'
          }
        ];
      }
      return routes;
    }
  },
  methods: {
    submitBug() {
      const formData = new FormData();
      for (const key in this.bugReport) {
        formData.append(key, this.bugReport[key]);
      }
      formData.append('ProblemUrl', window.location.href);
      this.axiosRequest('post', 'Application/ReportProblem', formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })
        .then(response => {
          this.showSuccessMessage('Bug reported with success');
        })
        .catch(err => {
          this.showErrorMessage(err);
        })
        .finally(() => {
          this.reportBugDialog = false;
          this.bugReport = {};
        });
    }
  }
};
</script>

<style lang="scss">
.navbar {
  border-bottom: solid 1px #3e474f;
  .logotype {
    height: 70px;
    max-height: unset;
  }
  .navbar-menu {
    padding-left: 4rem;
    @include from($widescreen) {
      padding-left: 6rem;
    }
  }
  .navbar-item {
    &.is-tab {
      font-weight: $weight-light;
      transition: all $regular-timing $regular-anim;
      &:not(:last-child) {
        margin-right: 1.5rem;
      }
      &.is-active {
        font-weight: $weight-bold;
      }
    }
  }

  .user-role-header {
    font-size: 1.8rem;
    font-weight: $weight-bold;
  }

  .organization {
    // font-size: 1.1rem;
    // text-transform: uppercase;
    font-family: $family-secondary;
    letter-spacing: 0.15em;
    text-transform: uppercase;
    font-size: 1.4rem;
  }
}
</style>
